export default {
  layout(context) {
    return context.store.state.settings.settings.customLayout || 'default'
  },
}
